export default "__VITE_ASSET__BvN3qOV___"